<template>
  <LuJhu lu-jhu-type="WeiShuDaXiaoLuJhu" />
</template>

<script>
import LuJhu from '@/components/desktop/common/trend/LuJhu'
export default {
  name: 'WeiShuDaXiao',
  components: {
    LuJhu
  }
}
</script>

